import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "weight-600 text-2xl lg:text-4xl font-semibold text-green leading-1 flex"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UmanaHeadline',
  props: {
    h: {},
    primaryColor: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (props.h == 'h1')
    ? (_openBlock(), _createElementBlock("h1", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
    : (props.h == 'h2')
      ? (_openBlock(), _createElementBlock("h2", {
          key: 1,
          class: _normalizeClass(["weight-600 text-xl lg:text-3xl font-semibold flex", { 'text-green': _ctx.primaryColor, 'text-black': !_ctx.primaryColor }])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2))
      : (props.h == 'h3')
        ? (_openBlock(), _createElementBlock("h3", {
            key: 2,
            class: _normalizeClass(["weight-600 text-lg lg:text-2xl font-semibold flex", { 'text-green': _ctx.primaryColor, 'text-gray-600': !_ctx.primaryColor }])
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 2))
        : _createCommentVNode("", true)
}
}

})